import React from "react";
import { Modal } from "antd";
import { IoArrowBackCircleOutline } from "react-icons/io5";

export const DialogBoxApply = ({ open, onCancel, children }) => {
  return (
    <Modal
      open={open}
      // onCancel={onCancel}
      footer={null}
      width="auto"
      onclose={false}
      closable={false}
      // closeIcon={
      //   <IoArrowBackCircleOutline className="w-7 h-7 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition duration-200" />
      // }
      className="!p-0"
      bodyStyle={{ padding: 0 }}
      centered
    >
      <div
        className="
          w-[60vw] sm:w-[70vw] md:w-[60vw] lg:w-[50vw] xl:w-[30vw] 
          max-w-[800px]
          mx-auto
          bg-white rounded-lg
        "
      >
        {children}
      </div>
    </Modal>
  );
};
